// src/components/CustomHeader.tsx
import React from "react";

interface CustomTaskListHeaderProps {
  headerHeight: number;
  rowWidth: string;
  fontFamily: string;
  fontSize: string;
}

const CustomTaskListHeader: React.FC<CustomTaskListHeaderProps> = ({
  headerHeight,
  rowWidth,
  fontFamily,
  fontSize,
}) => {
  return (
    <div
      className="custom-task-list-header"
      style={{
        display: "flex",
        flexDirection: "row",
        height: headerHeight,
        alignItems: "center",
        fontFamily,
        fontSize,
        width: "100%",
        backgroundColor: "#f2f9ff",

        borderBottom: "1px solid #d0d0d0",
        fontWeight: 600,
      }}
    >
      {/* 🧱 Fixed-width Name column */}
      <div
        className="header-item name-column"
        style={{
          minWidth: "320px",
          maxWidth: "320px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          padding: "0 10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          height: "100%",
          borderRight: "1px solid #d0d0d0",
        }}
      >
        Name
      </div>

      {/* 🗓 Start Date Column */}
      <div
        className="header-item"
        style={{
          width: "150px",
          minWidth: "150px",
          textAlign: "center",
          flexShrink: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          borderRight: "1px solid #d0d0d0",
          height: "100%",
        }}
      >
        <span>Actual Start Date</span>
        <div style={{ width: "100%", borderBottom: "1px solid #c8c8c8", marginBottom: "4px" }} />
        <span>Planned Start Date</span>
      </div>

      {/* 🗓 End Date Column */}
      <div
        className="header-item"
        style={{
          width: "150px",
          minWidth: "150px",
          textAlign: "center",
          flexShrink: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          borderRight: "1px solid #d0d0d0",
          height: "100%",
          
        }}
      >
        <span>Actual End Date</span>
        <div style={{ width: "100%", borderBottom: "1px solid #c8c8c8", marginBottom: "4px" }} />
        <span>Planned End Date</span>
      </div>

      {/* ⏱ Budgeted Hours Column */}
      <div
        className="header-item"
        title="Budgeted Hrs"
        style={{
          width: "120px",
          minWidth: "120px",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        Budgeted Hrs
      </div>
    </div>
  );
};

export default CustomTaskListHeader;